import { z } from 'zod';

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'] as const;

export const TimeSlotSchema = z.object({
  id: z.union([z.string(), z.number()]).optional(),
  start: z.string().min(1, 'Informe o horário'),
  end: z.string().min(1, 'Informe o horário'),
  isEnter: z.boolean().default(false),
  isExit: z.boolean().default(false),
}).refine(data => data.start < data.end, {
  message: 'O horário de término deve ser após o início.',
  path: ['end'],
});

export const DailyScheduleSchema = z.object({
  weekday: z.enum(WEEKDAYS), 
  dayName: z.string().optional(),
  active: z.boolean().default(false),
  timeSlots: z.array(TimeSlotSchema).max(4, 'É permitido no máximo 4 horários por dia.'),
});

export const SchoolShiftFormSchema = z.object({
  id: z.number().optional(),
  name: z.string()
    .min(3, 'O nome deve ter pelo menos 3 caracteres.')
    .max(40, 'O nome pode ter no máximo 40 caracteres.'),
  deviceIds: z.array(z.number()).min(1, 'Selecione pelo menos um dispositivo.'),
  weeklySchedule: z.array(DailyScheduleSchema).refine(
    (days) => days.some(day => day.active && day.timeSlots.length > 0),
    { message: 'Configure pelo menos um dia e um horário para salvar o turno.' }
  ),
});

export type SchoolShiftFormInput = z.infer<typeof SchoolShiftFormSchema>;